/**
 * Иторум API для портала
 * Спецификация Open API
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from "@angular/core";
import {
  HttpClient, HttpHeaders, HttpParams,
  HttpResponse, HttpEvent
} from "@angular/common/http";
import { CustomHttpUrlEncodingCodec } from "../encoder";

import { Observable } from "rxjs";

import { InlineResponse20023 } from "../model/inlineResponse20023";
import { InlineResponse20024 } from "../model/inlineResponse20024";
import { MeasureMeasureIdBody } from "../model/measureMeasureIdBody";
import { StepMeasureBody } from "../model/stepMeasureBody";

import { BASE_PATH, COLLECTION_FORMATS } from "../variables";
import { Configuration } from "../configuration";


@Injectable()
export class StepMeasureService {

  protected basePath = "https://dev.itorum-mr.ru";
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = "multipart/form-data";
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   * Delete step measure
   *
   * @param measureId Step control id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepMeasureMeasureIdDelete(measureId: number, observe?: "body", reportProgress?: boolean): Observable<any>;
  public apiStepMeasureMeasureIdDelete(measureId: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
  public apiStepMeasureMeasureIdDelete(measureId: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
  public apiStepMeasureMeasureIdDelete(measureId: number, observe: any = "body", reportProgress: boolean = false): Observable<any> {

    if (measureId === null || measureId === undefined) {
      throw new Error("Required parameter measureId was null or undefined when calling apiStepMeasureMeasureIdDelete.");
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<any>("delete", `${this.basePath}/api/step/measure/${encodeURIComponent(String(measureId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update step measure
   *
   * @param measureId Step measure id
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepMeasureMeasureIdPut(measureId: number, body?: MeasureMeasureIdBody, observe?: "body", reportProgress?: boolean): Observable<InlineResponse20023>;
  public apiStepMeasureMeasureIdPut(measureId: number, body?: MeasureMeasureIdBody, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<InlineResponse20023>>;
  public apiStepMeasureMeasureIdPut(measureId: number, body?: MeasureMeasureIdBody, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<InlineResponse20023>>;
  public apiStepMeasureMeasureIdPut(measureId: number, body?: MeasureMeasureIdBody, observe: any = "body", reportProgress: boolean = false): Observable<any> {

    if (measureId === null || measureId === undefined) {
      throw new Error("Required parameter measureId was null or undefined when calling apiStepMeasureMeasureIdPut.");
    }


    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      "application/json"
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json"
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.request<InlineResponse20023>("put", `${this.basePath}/api/step/measure/${encodeURIComponent(String(measureId))}`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Create step measure
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepMeasurePost(body?: StepMeasureBody, observe?: "body", reportProgress?: boolean): Observable<InlineResponse20023>;
  public apiStepMeasurePost(body?: StepMeasureBody, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<InlineResponse20023>>;
  public apiStepMeasurePost(body?: StepMeasureBody, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<InlineResponse20023>>;
  public apiStepMeasurePost(body?: StepMeasureBody, observe: any = "body", reportProgress: boolean = false): Observable<any> {


    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      "application/json"
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
      "application/json"
    ];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.request<InlineResponse20023>("post", `${this.basePath}/api/step/measure`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Get measures by step id
   *
   * @param stepId Step id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public apiStepStepIdMeasureGet(stepId: number, observe?: "body", reportProgress?: boolean): Observable<InlineResponse20024>;
  public apiStepStepIdMeasureGet(stepId: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<InlineResponse20024>>;
  public apiStepStepIdMeasureGet(stepId: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<InlineResponse20024>>;
  public apiStepStepIdMeasureGet(stepId: number, observe: any = "body", reportProgress: boolean = false): Observable<any> {

    if (stepId === null || stepId === undefined) {
      throw new Error("Required parameter stepId was null or undefined when calling apiStepStepIdMeasureGet.");
    }

    let headers = this.defaultHeaders;

    // authentication (bearerAuth) required
    if (this.configuration.accessToken) {
      const accessToken = typeof this.configuration.accessToken === "function"
        ? this.configuration.accessToken()
        : this.configuration.accessToken;
      headers = headers.set("Authorization", "Bearer " + accessToken);
    }
    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      "application/json"
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<InlineResponse20024>("get", `${this.basePath}/api/step/${encodeURIComponent(String(stepId))}/measure`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

}
